export const FORM_IDENTIFIER = 'app/DeedPage/EmailAttendeesForm';

export const INIT = 'app/DeedPage/EmailAttendeesForm/INIT';

export const SEND = 'app/DeedPage/EmailAttendeesForm/SEND';
export const SEND_SUCCESS = 'app/DeedPage/EmailAttendeesForm/SEND_SUCCESS';
export const SEND_FAILED = 'app/DeedPage/EmailAttendeesForm/SEND_FAILED';
